namespace app.support.constants {
    'use strict';

    let config: any = {
        gateway : {
            url: window.location.protocol + "//" + (window.location.hostname !== 'localhost' ? window.location.hostname : 'docker'),
            ws: "wss://" + (window.location.hostname !== 'localhost' ? window.location.hostname : 'docker'),
            port: 8765
        },
        //TODO Remover a necessidade de passar esses valores padrão. Permitir pegar do config, via um profile específico, que seria setado ao rodar como gulp serve
        onlyoffice : {
            url: "https://onlyofficeqa.stf.jus.br"
        },
        upgraded: {
            url: "https://localhost:4200/",
            loadStrategy: "eager"
        },
        msal: {
			clientId: undefined,
			tennantId: "common"
		}
    };

    if (window) _.merge(config, (<any>window).__config); // Utilizando o merge para não sobreescrever a configuração do gateway e onlyoffice todos, o que permite sobreescrever apenas alguma subpropriedade no config.

    let currentLocation = window.location;
    let placeholdersVariables  = {
        hash: currentLocation.hash,
        host: currentLocation.host,
        hostname: currentLocation.hostname,
        href: currentLocation.href,
        origin: currentLocation.origin,
        pathname: currentLocation.pathname,
        port: currentLocation.port,
        protocol: currentLocation.protocol,
        search: currentLocation.search
    };
    
    const expressionRegex = new RegExp("^([^|]*)\\|([^|]*)\\|([^|]*)$");

    let resolveCurrentLocationPlaceholders = (value: string) => {
        if (typeof value === "number") {
            return value;
        }
        var formatted = value;
        const placeholderRegex = new RegExp("\\{\\{([^\\}]*)\\}\\}", "g");
        let matches;
        while ((matches = placeholderRegex.exec(value)) !== null) {
            let expressionFull = matches[0];
            let expression = matches[1];

            let expressionMatches = expression.match(expressionRegex);
            if (expressionMatches) {
                let controlVariable = expressionMatches[1];
                if (placeholdersVariables[controlVariable]) {
                    expression = expressionMatches[2];
                } else {
                    expression = expressionMatches[3];
                }
            }

            if (placeholdersVariables.hasOwnProperty(expression)) {
                formatted = formatted.replace(expressionFull, placeholdersVariables[expression]);
            } else {
                formatted = formatted.replace(expressionFull, expression);
            }
        }
        
        return formatted;
    };

    let allowedPlaceholdersConfigs = ["gateway", "onlyoffice", "upgraded", "downgraded"];
    for (let i in config) {
        if (allowedPlaceholdersConfigs.indexOf(i) !== -1) {
            for (let k in config[i]) {
                if (typeof config[i][k] === "string") {
                    config[i][k] = resolveCurrentLocationPlaceholders(config[i][k]);
                }
            }
        }
    }

    /**
     * Propriedades compartilhadas da aplicação
     */
    export interface Properties {
        url: string;
        port: number;
        apiUrl: string;
        development: boolean;
        onlyofficeUrl: string;
        onlyofficeSecure: boolean;
        onlyofficePluginsUrl: string;
        upgradedUrl: string;
        upgradedLoadStrategy: string;
        msalClientId: string;
        msalTennantId: string;
    }

    angular.module('app.support.constants', []).constant("properties", <Properties>{
        url: config.gateway.url,
        port: config.gateway.port,
        apiUrl: config.gateway.url + ":" + config.gateway.port,
        apiWs: config.gateway.ws + ":" + config.gateway.port,
        development: (config.gateway.development ? config.gateway.development : true),
        onlyofficeUrl: config.onlyoffice.url,
        onlyofficeSecure: config.onlyoffice.secure,
        onlyofficePluginsUrl: config.onlyoffice.pluginsUrl,
        upgradedUrl: config.upgraded.url,
        upgradedLoadStrategy: config.upgraded.loadStrategy,
        msalClientId: config.msal.clientId,
        msalTennantId: config.msal.tennantId
    });
}
